import React, { useState } from "react";

import { FormButton } from "components";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { hotelDel } from "services/services-mia/SFHotel/SFHotelDel";

export default function DeleteModal({ updateList, hotel, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await hotelDel({
            SFHotelId: hotel?.SFHotelId,
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "El hotel ha sido eliminado exitosamente",
            functions
        );

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                nombre: hotel.SFHotelNombre,
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string(FORM_ERROR_MESSAGES.text)
                        .required(FORM_ERROR_MESSAGES.required)
                })
            }
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form
                className={styles.inputs}
                noValidate
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0em"
                }}
            >
                <div className={styles["column-sm"]} style={{ maxWidth: "320px", gap: "0.2em" }}>

                    <h2 style={{ textAlign: "center", margin: "1em 0 0.8em 0", lineHeight: "1.3" }}>
                        Estás por eliminar el hotel <br />
                        <span style={{ fontSize: "1em", fontWeight: "bold" }}>
                            {hotel.SFHotelNombre}
                        </span>
                    </h2>
                    <h5 style={{
                        textAlign: "center",
                        margin: "0",
                        fontWeight: 500,
                        color: "#000000ff",
                        fontSize: "0.85em",
                        lineHeight: "1.4"
                    }}>
                        Una vez eliminado, no podrás recuperarlo. <br /> ¿Querés continuar?
                    </h5>

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Confirmar" }}
                        onCloseModal={closeModal}
                    />

                </div>
            </Form>
        </Formik>
    );
}